/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localize } from '../../translations.js';
import { SupportedLocale } from '../../model.js';
const LOADING_MESSAGES = [
    'ai.chat.loading.message.one',
    'ai.chat.loading.message.two',
    'ai.chat.loading.message.three',
    'ai.chat.loading.message.four',
];
let PwcAiLoader = class PwcAiLoader extends LitElement {
    constructor() {
        super(...arguments);
        this.locale = SupportedLocale.en_US;
        this._currentMessageIndex = 0;
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        // Show first two messages
        this._messageRotationTimer = window.setInterval(() => {
            if (this._currentMessageIndex < 2) {
                this._currentMessageIndex += 1;
            }
            else {
                // Loop between 3rd and 4th message
                this._currentMessageIndex = this._currentMessageIndex === 2 ? 3 : 2;
            }
        }, 5000);
    }
    disconnectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.disconnectedCallback();
        if (this._messageRotationTimer) {
            window.clearInterval(this._messageRotationTimer);
            this._messageRotationTimer = undefined;
        }
    }
    render() {
        const currentMessage = localize(this.locale, LOADING_MESSAGES[this._currentMessageIndex]);
        return html `
      <div class="loading-bar-box">
        ${currentMessage}
        <div class="loading-bar-container">
          <div class="loading-bar"></div>
        </div>
      </div>
    `;
    }
};
PwcAiLoader.styles = css `
    :host {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .loading-bar-box {
      padding: 12px 12px 14px 12px;
      width: 240px;
    }

    .loading-bar-container {
      margin-top: 8px;
      height: 4px;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      overflow: hidden;
      position: relative;
    }

    .loading-bar {
      position: absolute;
      height: 100%;
      width: 50%;
      background: linear-gradient(
        90deg,
        #26a9d3 0%,
        #0b3cea 22.4%,
        #3d17dc 43.4%,
        #611096 65%,
        #a82c35 87%,
        #ff7e3b 100%
      );
      border-radius: 2px;
      animation: loading 1.5s infinite ease-in-out;
    }

    @keyframes loading {
      0% {
        left: -50%;
      }
      100% {
        left: 100%;
      }
    }
  `;
__decorate([
    property({ attribute: 'locale', type: String })
], PwcAiLoader.prototype, "locale", void 0);
__decorate([
    state()
], PwcAiLoader.prototype, "_currentMessageIndex", void 0);
PwcAiLoader = __decorate([
    customElement('pwc-ai-loader')
], PwcAiLoader);
export { PwcAiLoader };
//# sourceMappingURL=pwc-ai-loader.js.map